import {
  EP,
  ASSINATURA_SUPORTE,
  ACOMPANHAMENTO_BASICO,
  ACOMPANHAMENTO_ESSENCIAL,
  ACOMPANHAMENTO_ELITE,
  GESTAO_FINANCEIRA,
  SUPORTE_OPEN,
  ACOMPANHAMENTO_BASICO_OPEN,
  ACOMPANHAMENTO_ESSENCIAL_OPEN,
  ACOMPANHAMENTO_ELITE_OPEN,
  ACOMPANHAMENTO_PREMIUM,
  ACCOMPANHAMENTO_OFF_FUTURO,
} from "./financial";

/**
 * Empresas do grupo para as quais o PN emite nota — espelho de `App\Constants\PayingCompanyTypes`.
 *
 * Os ids são gravados explicitamente pelo seed `2026_08_20_000201_seed_paying_companies`. Não existe
 * rota que liste as empresas, então esta lista é a fonte da UI: um terceiro CNPJ precisa entrar aqui
 * E no seed.
 */
export const PLATFORM_ID = 1;
export const HUB_ID = 2;

/**
 * Sentinela do filtro "sem empresa pagadora". Não é id, é string, exatamente para nunca colidir com
 * um id — o backend compara com `(string)` antes de cair no `where` numérico.
 */
export const NONE_FILTER = "none";

export const PAYING_COMPANIES = [
  { id: PLATFORM_ID, name: "Futuro Plataforma", cnpj: "48.312.560/0001-08" },
  { id: HUB_ID, name: "Futuro Hub", cnpj: "40.411.705/0001-16" },
];

/** Nome sem CNPJ não é conferível: o Financeiro valida o lançamento pelo número. */
export const payingCompanyLabel = (id) => {
  const company = PAYING_COMPANIES.find((item) => item.id === Number(id));
  return company ? `${company.name} — ${company.cnpj}` : "";
};

export const PAYING_COMPANY_OPTIONS = PAYING_COMPANIES.map((company) => ({
  id: company.id,
  label: `${company.name} — ${company.cnpj}`,
}));

export const PAYING_COMPANY_FILTER_OPTIONS = [
  ...PAYING_COMPANY_OPTIONS,
  { id: NONE_FILTER, label: "Sem empresa pagadora" },
];

/**
 * Espelho de `PayingCompanyResolver::platformFinancialSolutionIds()`.
 *
 * ⚠️ NÃO reaproveite `isAssinatura()` de `constants/financial.js` no lugar desta lista: aquela
 * inclui 274/275 (App Meu Futuro), que no backend caem na Hub. Usá-la mostraria o CNPJ errado na
 * tela para todo contrato de app.
 *
 * Esta cópia é só pré-checagem de UX. Quem grava o CNPJ é o backend, que re-deriva a partir de
 * `contract_ids` no submit — se as duas listas divergirem, o pior caso é um 400 explicado, nunca uma
 * nota emitida pela empresa errada.
 */
export const PLATFORM_FINANCIAL_SOLUTION_IDS = [
  EP,
  ASSINATURA_SUPORTE,
  ACOMPANHAMENTO_BASICO,
  ACOMPANHAMENTO_ESSENCIAL,
  ACOMPANHAMENTO_ELITE,
  GESTAO_FINANCEIRA,
  SUPORTE_OPEN,
  ACOMPANHAMENTO_BASICO_OPEN,
  ACOMPANHAMENTO_ESSENCIAL_OPEN,
  ACOMPANHAMENTO_ELITE_OPEN,
  ACOMPANHAMENTO_PREMIUM,
  ACCOMPANHAMENTO_OFF_FUTURO,
];

export const payingCompanyFromFinancialSolutionId = (financialSolutionId) =>
  PLATFORM_FINANCIAL_SOLUTION_IDS.includes(Number(financialSolutionId))
    ? PLATFORM_ID
    : HUB_ID;
